// When this navigation's editor splash first showed. The route's fallback shows the splash while the editor's code
// arrives, then the editor shows its own, both under the same location: the second carries on from the first instead of
// starting the animation again. A new navigation to the editor (another location key) always starts afresh.
let current: { key: string; startedAt: number } | null = null;

/** This navigation's start (its location key), set by the first splash to ask. */
export const splashStart = (key: string, now: number = performance.now()): number => {
  if (current?.key !== key) current = { key, startedAt: now };
  return current.startedAt;
};

/** The splash is gone, so the next load starts afresh. */
export const splashDone = (): void => {
  current = null;
};

/** What the editor's splash waits for, each a real stage of the load. */
export interface SplashStages {
  /** The editor's code has arrived (false only in the route's fallback). */
  codeLoaded: boolean;
  /** The scene's data is in. */
  isSceneReady: boolean;
  /** The organisation is in, so the side menu and timeline are right from the first frame. */
  orgLoaded: boolean;
  /** The 3D view says it's ready. */
  sceneLoaded: boolean;
}

/** How far the load is, out of 100: a quarter for each stage done, never a guess from the clock. */
export const splashProgress = ({ codeLoaded, isSceneReady, orgLoaded, sceneLoaded }: SplashStages): number =>
  25 * [codeLoaded, codeLoaded && isSceneReady, codeLoaded && orgLoaded, codeLoaded && sceneLoaded].filter(Boolean).length;
